import { closestCenter, DndContext, DragEndEvent, KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { EntityId } from "@reduxjs/toolkit";
import React, { useEffect, useState } from "react";
import { AuthAdmin } from "../../../auth/types/auth.types";
import ExperiencePrerequisiteListPresentation from "../../presentation/experiencePrerequisiteListPresentation/ExperiencePrerequisiteListPresentation";
import { ExperienceCard } from "../../types/types";
import { useUpdatePositionMutation } from "../../api/experienceCardApiSlice";
type ExperiencePrerequisiteListProp = {
    prerequisiteId: string;
  onEdit: (id: EntityId) => void;
  onReview: (id: EntityId) => void;
    admin: AuthAdmin | null
    permissionResult:any
    list?:ExperienceCard[]
};
const ExperiencePrerequisiteList: React.FC<ExperiencePrerequisiteListProp> = ({
  prerequisiteId,
  onEdit,
  onReview,
  admin,
  permissionResult,
  list
}) => {
 
const [items,setItems] = useState<ExperienceCard[]>(list ?? []);
const sensors = useSensors(
  useSensor(PointerSensor),
  useSensor(KeyboardSensor,{
    coordinateGetter:sortableKeyboardCoordinates
  })
)
const [updatePosition] = useUpdatePositionMutation();

useEffect(() => {
    setItems(list ?? []);
},[list])

const handleDragEnd = (event:DragEndEvent) => {
  const { active, over } = event;
  if (!over || active.id === over.id) {
    return;
  }

  setItems((currentItems) => {
    const oldIndex = currentItems.findIndex((item) => item._id === active.id);
    const newIndex = currentItems.findIndex((item) => item._id === over.id);

    if (oldIndex === -1 || newIndex === -1) {
      return currentItems;
    }

    void updatePosition({
      oldID: active.id as EntityId,
      newID: over.id as EntityId,
      oldPositon: oldIndex,
      newPositon: newIndex
    }).unwrap().catch((error) => {
      console.error(error);
    });

    return arrayMove(currentItems, oldIndex, newIndex);
  });
}




  return (
    <>
      {list && (
        
            <tr>
            <td colSpan={12} style={{width: '100%'}}>
        <table style={{position:'relative', left:50, width: 'calc(100% - 50px)' ,    borderCollapse: 'separate',
    borderSpacing: '0 10px'}}>
          <tbody>
        {/* {list && list.map((pExperience) =>  
            <ExperiencePrerequisiteListPresentation
              key={pExperience._id}
              item={pExperience!}
              onEdit={onEdit}
              onReview={onReview}
              admin={admin}
              permissionResult ={permissionResult}
              
            />
          )} */}
          <DndContext 
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext items={items.map(item => item._id)} strategy={verticalListSortingStrategy}>
              {items.map((item) => (
                <ExperiencePrerequisiteListPresentation
                key={item._id}
                item={item!}
                onEdit={onEdit}
                onReview={onReview}
                admin={admin}
                permissionResult ={permissionResult}
                
              />
              ))}
            </SortableContext>
          </DndContext>
        </tbody></table>

        </td>
        </tr>

        
      )}
    </>
  )
}

export default ExperiencePrerequisiteList
